import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Typography } from "@mui/material";

const SearchableSelect = ({
    options,
    value: propsValue,
    onChange,
    isMultiSelect = false,
    labelStyle = {},
    textFieldStyle = {},
    label = "",
    placeholder = "Please select...",
    required = true,
    disabled = false,
}) => {
    const [selected, setSelected] = useState(
        propsValue || (isMultiSelect ? [] : null)
    );

    useEffect(() => {
        setSelected(propsValue);
    }, [propsValue]);

    const handleChange = (event, newValue) => {
        setSelected(newValue);
        if (typeof onChange === "function") {
            if (isMultiSelect) {
                const selectedValues = Array.isArray(newValue)
                    ? newValue.map((item) => item?.value)
                    : [];
                const selectedLabels = Array.isArray(newValue)
                    ? newValue.map((item) => item?.label)
                    : [];
                onChange(selectedValues, selectedLabels);
            } else {
                const selectedValue = newValue?.value ?? "";
                const selectedLabel = newValue?.label ?? "";
                onChange(selectedValue, selectedLabel);
            }
        }
    };

    return (
        <>
            {label && (
                <Typography
                    variant="subtitle1"
                    sx={{
                        whiteSpace: "nowrap",
                        color: "#333",
                        fontWeight: 700,
                        mb: 0.5,
                        ...labelStyle,
                    }}
                >
                    {label}
                </Typography>
            )}
            <Autocomplete
                disabled={disabled}
                multiple={isMultiSelect}
                options={options || []}
                getOptionLabel={(option) => option.label || ""}
                value={selected || (isMultiSelect ? [] : null)}
                isOptionEqualToValue={(option, value) => option.value === value?.value}
                onChange={handleChange}
                noOptionsText="No options"
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={placeholder}
                        required={required}
                        variant="outlined"
                        sx={{
                            width: "100%",
                            borderRadius:"4px",
                            backgroundColor: "#fff",
                            "& .MuiOutlinedInput-root": {
                                p: "0!important"
                            },
                            "& .MuiAutocomplete-input": {
                                py: "4px!important",
                                pl: "16px!important",
                            },
                            ...textFieldStyle,
                        }}
                    />
                )}
                sx={{
                    width: "100%",
                }}
            />
        </>
    );
};

export default SearchableSelect;
